import { render, staticRenderFns } from "./BibliographyDetailCollectionTable.vue?vue&type=template&id=f9e00fbc&"
import script from "./BibliographyDetailCollectionTable.vue?vue&type=script&lang=ts&"
export * from "./BibliographyDetailCollectionTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports